import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonModal,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import React from 'react';
import useIonicModalProps from '../../../hooks/useIonicModalProps';
import { JSX } from '@ionic/core/components';
import TermsAndConditions from './TermsAndConditions';
import styled from 'styled-components';

interface TermsAndConditionsModalProps extends JSX.IonModal {}

const Wrapper = styled.div`
  padding: 24px;
`;

const TermsAndConditionsModal: React.FC<TermsAndConditionsModalProps> = (
  props
) => {
  const modalProps = useIonicModalProps();
  return (
    <IonModal {...props} {...modalProps}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Terms and Conditions</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={() => modalProps.ref.current?.dismiss()}>
              Close
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <Wrapper>
          <TermsAndConditions />
        </Wrapper>
      </IonContent>
    </IonModal>
  );
};

export default TermsAndConditionsModal;
